export enum WunschterminLabels {
    WUNSCHABHOL_BZW_LIEFERTERMIN = 'Wunschabhol- bzw. liefertermin',
    WUNSCHABHOLTERMIN = 'Wunschabholtermin',
    WUNSCHLIEFERTERMIN = 'Wunschliefertermin',
    TAGESZEIT = 'Tageszeit',
    ABHOL_BZW_LIEFERTERMIN = 'Abhol- bzw. Liefertermin',
    SELECT_PLACEHOLDER = 'bitte auswählen',
    UHRZEIT = 'Uhrzeit',
}
